import React from 'react';
import { Button } from '@mui/material';
import { GreenChip, RedChip } from '../../Venue/components';
import { openInNewTab } from '../../utils';

export const StripeCustomerChip = ({ organization }) => {
  if (!organization.stripeCustomerId) {
    return <RedChip label="No Stripe Customer" />;
  }
  return (
    <>
      <GreenChip
        label={organization.stripeCustomerId}
        onClick={openInNewTab({
          url: `https://dashboard.stripe.com/customers/${organization.stripeCustomerId}`,
        })}
      />
      <Button
        variant="outlined"
        color="primary"
        href={`https://dashboard.stripe.com/customers/${organization.stripeCustomerId}`}
        target="_blank"
        rel="noreferrer"
      >
        Go to Customer Billing in Stripe
      </Button>
    </>
  );
};
